import { Wrench, Trees } from "lucide-react";
import { RadioGroup, CheckboxGroup, FormTextarea } from "./FormInput";

const CONDITION_OPTIONS = [
  'Excellent', 'Good', 'Fair', 
  'Needs Minor Repairs', 'Needs Major Repairs', 'Full Rehab Needed'
];

const ISSUE_OPTIONS = [
  'Roof Issues', 'Foundation Issues', 'Plumbing Issues', 
  'Electrical Issues', 'HVAC Issues', 'Floor Issues',
  'Fire Damage', 'Water Damage', 'Mold', 'Code Violations', 'None'
];

const UPDATE_OPTIONS = ['Yes', 'No', 'Partially'];

const PropertyConditionStep = ({ formData, onChange, onCheckboxChange }) => {
  const isVacantLand = formData.property_type === 'Vacant Land';

  // For Vacant Land, show a different step
  if (isVacantLand) {
    return (
      <div className="space-y-6 animate-fade-in" data-testid="property-condition-step">
        <h2 className="text-xl font-bold text-white flex items-center gap-2">
          <Trees className="w-5 h-5 text-[#D4AF37]" />
          Land Description
        </h2>
        
        <div className="space-y-4">
          <div className="bg-[#D4AF37]/10 border border-[#D4AF37]/30 p-4 mb-4">
            <p className="text-[#D4AF37] text-sm">
              Since you&apos;re selling vacant land, tell us more about your property. 
              This helps us provide you with the most accurate offer.
            </p>
          </div>

          <FormTextarea
            label="Describe your land"
            required
            name="land_description"
            value={formData.land_description || ''}
            onChange={onChange}
            placeholder="Tell us about your land: terrain features, trees, water features, any structures, previous use, etc."
            rows={5}
          />

          <div className="text-sm text-[#A3A3A3] bg-[#0A0A0A] p-4 border border-white/10">
            <p className="font-semibold text-white mb-2">Helpful things to mention:</p>
            <ul className="list-disc list-inside space-y-1">
              <li>Terrain type (flat, sloped, wooded, cleared)</li>
              <li>Any water features (creek, pond, lake access)</li>
              <li>Existing structures (well, septic, electric pole)</li>
              <li>Previous land use</li>
              <li>Neighboring properties</li>
              <li>Any known restrictions or easements</li>
            </ul>
          </div>
        </div>
      </div>
    );
  }

  // For houses/buildings, show the standard condition questions
  return (
    <div className="space-y-6 animate-fade-in" data-testid="property-condition-step">
      <h2 className="text-xl font-bold text-white flex items-center gap-2">
        <Wrench className="w-5 h-5 text-[#D4AF37]" />
        Property Condition
      </h2>
      
      <div className="space-y-4">
        <RadioGroup
          label="What condition is the property in?"
          name="property_condition"
          options={CONDITION_OPTIONS}
          value={formData.property_condition}
          onChange={onChange}
          required
        />

        <CheckboxGroup
          label="Does the property have any major issues? (Select all that apply)"
          name="major_issues"
          options={ISSUE_OPTIONS}
          selected={formData.major_issues}
          onChange={onCheckboxChange}
          required
          columns={3}
        />

        <RadioGroup
          label="Has the property been updated recently?"
          name="recently_updated"
          options={UPDATE_OPTIONS}
          value={formData.recently_updated}
          onChange={onChange}
          required
        />
      </div>
    </div>
  );
};

export default PropertyConditionStep;
